export const _setIsQualityAssuranceDataLoaded = (state, action) => {
  state.IsQualityAssuranceDataLoaded = action.payload;
};

//   export const _setQualityAssuranceReviewId = (state, action) => {
//     state.QualityAssuranceReviewId = action.payload;
//   };

export const _setReviewDate = (state, action) => {
  state.reviewDate = action.payload;
};

export const _setLastReviewDate = (state, action) => {
  state.lastReviewDate = action.payload;
};
export const _setNextReviewDate = (state, action) => {
  state.nextReviewDate = action.payload;
};
export const _setQuestion1 = (state, action) => {
  state.question1 = action.payload;
};

export const _setQuestion2 = (state, action) => {
  state.question2 = action.payload;
};

export const _setQuestion3 = (state, action) => {
  state.question3 = action.payload;
};
export const _setQuestion4 = (state, action) => {
  state.question4 = action.payload;
};

export const _setQuestion5 = (state, action) => {
  state.question5 = action.payload;
};

export const _setQuestion6 = (state, action) => {
  state.question6 = action.payload;
};

export const _setQuestion7 = (state, action) => {
  state.question7 = action.payload;
};

export const _setQuestion8 = (state, action) => {
  state.question8 = action.payload;
};
export const _setQuestion9 = (state, action) => {
  state.question9 = action.payload;
};
export const _setQuestion10 = (state, action) => {
  state.question10 = action.payload;
};
export const _setQuestion11 = (state, action) => {
  state.question11 = action.payload;
};
export const _setQuestion13 = (state, action) => {
  state.question13 = action.payload;
};
export const _setQuestion14 = (state, action) => {
  state.question14 = action.payload;
};
export const _setQuestion15 = (state, action) => {
  state.question15 = action.payload;
};
export const _setExceptionComments = (state, action) => {
  state.exceptionComments = action.payload;
};
export const _setFollowUpComments = (state, action) => {
  state.followUpComments = action.payload;
};
export const _setDateCreated = (state, action) => {
  state.dateCreated = action.payload;
};
export const _setDateEdited = (state, action) => {
  state.dateEdited = action.payload;
};
export const _setReviewCreatedBy = (state, action) => {
  state.reviewCreatedBy = action.payload;
};
export const _setEditedBy = (state, action) => {
  state.editedBy = action.payload;
};
